import React, { memo } from 'react';
import { NodeProps, Position } from 'reactflow';
import { Shuffle, RotateCw, Percent, Gauge, Star } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { RouterNodeData } from '../../types/nodes';

const routerIcons = {
  random: <Shuffle />,
  round_robin: <RotateCw />,
  percentage: <Percent />,
  load_balance: <Gauge />,
  priority: <Star />
};

const routerLabels = {
  random: 'Router Casuale',
  round_robin: 'Round Robin',
  percentage: 'Percentuale',
  load_balance: 'Bilanciamento',
  priority: 'Priorità'
};

const RouterNode: React.FC<NodeProps<RouterNodeData>> = memo(({ selected, data }) => {
  const icon = routerIcons[data.routerType] || <Shuffle />;
  const label = routerLabels[data.routerType] || 'Router';
  
  const getPreview = () => {
    const routeCount = data.config.routes?.length || 0;
    return `${routeCount} percorsi`;
  };

  // Genera handle aggiuntivi per ogni route
  const additionalHandles = data.config.routes?.map((route, index) => ({
    id: `route-${route.id}`,
    position: Position.Right,
    type: 'source' as const,
    style: { 
      top: `${30 + (index * 20)}%`,
      background: '#fff',
      border: '2px solid #4ade80'
    }
  })) || [];

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-violet-500 to-purple-600"
      handles={{
        target: true,
        source: false, // Disabilitiamo il source default perché usiamo handle multipli
        additionalHandles
      }}
    />
  );
});

RouterNode.displayName = 'RouterNode';

export default RouterNode;
